import { useState, useEffect } from 'react';

/**
 * Custom hook for responsive design
 * @param {string} query - Media query string (e.g. '(max-width: 1200px)')
 * @returns {boolean} - Whether the media query matches
 */
const useMediaQuery = (query) => {
	const [matches, setMatches] = useState(false);

	useEffect(() => {
		const mediaQuery = window.matchMedia(query);
		setMatches(mediaQuery.matches);

		const handler = (event) => {
			setMatches(event.matches);
		};

		// Modern approach with addEventListener
		mediaQuery.addEventListener('change', handler);

		// Cleanup function
		return () => {
			mediaQuery.removeEventListener('change', handler);
		};
	}, [query]); // Re-run if query changes

	return matches;
};

export default useMediaQuery;
